<template>
  <v-card-text :class="['py-3', { 'en-card-text-padding': $i18n.locale === 'en' }]">
    <div
      v-if="defecationTemp"
      :class="['d-flex align-center justify-center mb-5 before-correction-row', { 'flex-wrap': $i18n.locale === 'en' }]"
    >
      <div :class="['before-correction-label', { 'text-no-wrap': $i18n.locale === 'en' }]">{{ $t('defecationModal.beforeCorrection') }}</div>
      <v-chip color="defecation" class="chip-auto-width defecation-label-chip" variant="outlined" size="x-small">{{ $t('defecationModal.defecationLabel') }}</v-chip>
      <div class="">{{ formatTime(defecationTemp.recordedAt) }}</div>
      <div class="defecation-status-text">{{ showDefecationStatus(defecationTemp.state) }}</div>
    </div>
    <div class="defecation-modal-time-field">
      <v-menu
        v-model="isRecordetAtPicker"
        :close-on-content-click="false"
        location="bottom start"
        transition="scale-transition"
        min-width="290px"
        max-width="290px"
      >
        <template v-slot:activator="{ props }">
          <v-text-field
            :model-value="localRecordedAt"
            :label="$t('defecationModal.timeLabel')"
            prepend-icon="mdi-clock-time-four-outline"
            :rules="[rules.required]"
            readonly
            v-bind="props"
            variant="outlined"
            density="compact"
            color="primary"
          ></v-text-field>
        </template>

        <v-time-picker
          v-if="isRecordetAtPicker"
          v-model="localRecordedAt"
          format="24hr"
          locale="ja"
          :allowed-minutes="allowedStep"
          @update:model-value="onTimePicked"
          color="primary"
          @keydown.capture.prevent
        ></v-time-picker>
      </v-menu>
    </div>

    <v-select
      :model-value="state"
      @update:model-value="onChangeState"
      :items="choices"
      item-title="text"
      item-value="value"
      :rules="[rules.required]"
      :label="$t('defecationModal.stateLabel')"
      variant="outlined"
      density="compact"
    ></v-select>
  </v-card-text>
</template>
<script lang="ts">
import Vue, { PropType, defineComponent } from 'vue';
import dayjs from 'dayjs';
import { DefecationStatus, DefecationStatusType, NurseryDefecationResponse } from 'chaild-api/lib';
import rules from '@/service/ValidRules';

// model
// import { VForm } from '@/model/vuetify/VForm';

export default defineComponent({
  name: 'DefecationModal',

  emits: ['update:recordedAt', 'update:state'],

  props: {
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
    defecationTemp: {
      type: Object as PropType<NurseryDefecationResponse>,
    },
    recordedAt: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: '',
    },
  },

  computed: {
    rules() {
      return rules;
    },
    form() {
      return (this.$refs as any).post_defecation_form;
    },
    choices() {
      return [
        {
          text: (this as any).$t('defecation.hard'),
          value: DefecationStatus.hard,
        },
        {
          text: (this as any).$t('defecation.normal'),
          value: DefecationStatus.normal,
        },
        {
          text: (this as any).$t('defecation.soft'),
          value: DefecationStatus.soft,
        },
        {
          text: (this as any).$t('defecation.diarrhea'),
          value: 'diarrhea' as DefecationStatusType,
        },
      ];
    },
  },

  watch: {
    recordedAt(newVal) {
      if (newVal) {
        this.localRecordedAt = dayjs(newVal).format('HH:mm');
      } else {
        this.localRecordedAt = '';
      }
    },
  },

  data: () => ({
    btnLoading: false,
    isRecordetAtPicker: false,
    localRecordedAt: '',
  }),

  methods: {
    allowedStep: (m: any) => m % 5 === 0,
    onTimePicked(newTime: string | null) {
      if (!newTime) return;
      this.localRecordedAt = newTime;
      const [hour, minute] = newTime.split(':');
      const iso = dayjs().hour(Number(hour)).minute(Number(minute)).second(0).millisecond(0).toISOString();
      this.$emit('update:recordedAt', iso);
      this.isRecordetAtPicker = false;
    },
    onChangeState(newState: string) {
      this.$emit('update:state', newState);
    },
    showDefecationStatus(state: DefecationStatusType) {
      if (state === 'hard') {
        return (this as any).$t('defecation.hard');
      } else if (state === 'normal') {
        return (this as any).$t('defecation.normal');
      } else if (state === 'soft') {
        return (this as any).$t('defecation.soft');
      } else if (state === 'diarrhea') {
        return (this as any).$t('defecation.diarrhea');
      }
    },
    formatTime(time: string) {
      const nowTime = dayjs(time).format('HH:mm');
      return nowTime;
    },
  },
  mounted() {
    if (this.recordedAt) {
      this.localRecordedAt = dayjs(this.recordedAt).format('HH:mm');
    }
  },
});
</script>
<style lang="scss" scoped>
.chip-auto-width {
  width: auto !important;
  min-width: fit-content !important;
  
  :deep(.v-chip__content) {
    white-space: nowrap;
    overflow: visible;
  }
}

.defecation-label-chip {
  flex-shrink: 0;
  white-space: nowrap;
}

.before-correction-label {
  margin-right: 2px;
}

.before-correction-row {
  column-gap: 8px;
  row-gap: 4px;
}

.defecation-status-text {
  text-align: center;
  overflow-wrap: break-word;
}

.defecation-modal-time-field {
  margin-bottom: 10px;
}

.en-card-text-padding {
  padding-left: 4px !important;
  padding-right: 4px !important;
  line-height: 1 !important;
}
</style>
